// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d65afa49","453":"68741114","455":"1fc2b83b","977":"31b3dea3"}[chunkId] + ".chunk.js";
};